<template>
    <div>
      <v-dialog v-model="dialog" persistent max-width="500">
        <v-card style="overflow: hidden;">
          <v-row no-gutters align="center" justify="center">
            <v-col cols="12" style="margin-top:20px;">
              <v-row no-gutters justify="center">
                <span style="color:#00A99D; font-weight: 500; font-size: 24px; font-family: 'Prompt';">ยืนยันส่งกลับแก้ไขเอกสาร</span>
              </v-row>
            </v-col>
            <v-col cols="12" style="margin-top:10px;">
              <v-row no-gutters justify="center">
                  <span style="color:#757575; font-size: 16px;">คุณแน่ใจหรือไม่ว่าต้องการส่งกลับแก้ไข</span>
              </v-row>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-row class="mx-0">
              <v-col cols="6" class="py-5 pl-2">
                <v-btn
                  outlined
                  block
                  color="#FF8082"
                  @click="(dialog = false)"
                >
                  <span>ยกเลิก</span>
                </v-btn>
              </v-col>
              <v-col cols="6" class="py-5 pr-2">
                <v-btn
                  block
                  dark
                  depressed
                  color="#00A99D"
                  @click="Revers()"
                >
                  <span>ยืนยัน</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  
  export default {
    props: ["from"],
    data() {
      return {
        dialog: false,
        data: "",
      };
    },
    methods: {
      openDialogRevers(item) {
        this.dialog = true;
        this.data = item;
      },
      Revers() {
        var body = {
          status: "Wait",
          doc_id:this.data._id
        }
        // this.axios.put(`${process.env.VUE_APP_BACKEND_URL}/v1/updatestatus_healtcheck`, body)
        this.axios.put(`${process.env.VUE_APP_BACKEND_URL}/v1/updatestatus_healtcheck`, body)
        .then((res) => {
            if (res.data.result === "success") {
            this.$swal({
                title:"<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>ส่งกลับข้อมูลสำเร็จ</span>",
                icon: "success",
                showConfirmButton: false,
                confirmButtonText: "ปิด",
                confirmButtonColor: "#00A99D",
                timer: 1500,
            })
            this.note = ''
            this.dialog = false;
            this.$emit("close");
            } else {
            this.$swal({
                title:"<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>ส่งกลับข้อมูลไม่สำเร็จ</span>",
                icon: "error",
                showConfirmButton: false,
                confirmButtonText: "ปิด",
                confirmButtonColor: "#00A99D",
                timer: 1500,
            })
            this.note = ''
            this.dialog = false;
            this.$emit("close");
            }
        });
      },
    },
  };
  </script>
  
  <style scoped>
  ::v-deep
    .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
    > .v-input__control
    > .v-input__slot {
    border: 1px solid #e8e9e9;
    box-sizing: border-box;
    border-radius: 6px;
    box-shadow: none;
  }
  </style>
  